import FeedbackMain from '@/components/FeedbackMain'
const FeedbackPage = () => {
    const element = (<>
        <FeedbackMain />
    </>)
    return element
}

export default FeedbackPage